export default __webpack_public_path__ + "static/media/sayswitch.0af7cfd7.PNG";